import React from "react";
// import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import GoogleMap from "../Common/GoogleMap/GoogleMap";
import LanguageIcon from "@mui/icons-material/Language";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import RamTech_IT_Logo from "../../assets/Logo/ramTech_Logo.png";
import { Link, NavLink } from "react-router-dom";

const listStyle = {
  position: "relative",
};

const Footer = () => {
  return (
    <footer className="footer">
      <style>
        {`
            .arrow li::before {
              content: "";
              position: absolute;
              left: .8em;
              top: 0.35em;
              width: 0;
              height: 0;
              border-top: 0.4em solid transparent;
              border-bottom: 0.4em solid transparent;
              border-left: 0.4em solid #1DB954;
            }
  .verticalLine {
              border-right: 2px solid #74C365;
              height: 200px;
              position: relative;
            }
            /* Media Query for small screens */
            @media (max-width: 768px) {
              .verticalLine {
                border-right: none;
                border-bottom: 2px solid #6DB471;
                margin-bottom: 20px;
              }
            }
          `}
      </style>
      <section className="bg-dark py-4 px-3">
        <div className="container-fluid">
          <div
            className="row"
            style={{ display: "flex", alignItems: "stretch" }}
          >
            <div className="col-xs-12 col-md-4 col-lg-3 align-self-center verticalLine">
              <GoogleMap />
            </div>
            <div className="col-xs-12 col-md-4 col-lg-3 align-self-center verticalLine">
              <div className="widget">
                <h4 style={{ color: "#74C365", textAlign: "center" }}>
                  Quick Links
                </h4>
                <ul className="list-unstyled arrow">
                  <li style={listStyle}>
                    <a
                      href="https://www.india.gov.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      National Portal of India
                    </a>
                    {/* <span style={beforeStyle}></span> */}
                  </li>
                  <li style={listStyle}>
                    <a
                      href="https://agriwelfare.gov.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      Ministry of Agriculture
                    </a>
                  </li>
                  <li style={listStyle}>
                    <a
                      href="https://icar.org.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      ICAR
                    </a>
                  </li>
                  <li style={listStyle}>
                    <a
                      href="https://nrcb.org.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      ICAR-NRCB
                    </a>
                  </li>
                  <li style={listStyle}>
                    <NavLink
                      to="/privacy-policy"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                  <li style={listStyle}>
                    <NavLink
                      to="/return-and-refund-policy"
                      className="link-secondary text-decoration-none text-white"
                      style={{ marginLeft: "40px" }}
                    >
                      Return and Refund Policy
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-md-4 col-lg-6 ">
              <div className="widget">
                <h4 style={{ color: "#74C365", textAlign: "center" }}>
                  Contact Details
                </h4>
                <div className="row">
                  <div className="col-xl-6 col-lg-12 col-md-12">
                    <div className="row">
                      <div className="col-2">
                        <LocationOnIcon
                          className=" me-3"
                          style={{ color: "#1DB954" }}
                        />
                      </div>
                      <div className="col-10">
                        <p className="text-light">ICAR-NRCB</p>
                        <p className="text-light">Thogamalai Road,</p>
                        <p className="text-light">Thayanur Post,</p>
                        <p className="text-light">Tiruchirapalli - 620 102,</p>
                        <p className="text-light">Tamil Nadu, India.</p>
                      </div>
                    </div>
                    <div className="row my-3">
                      <div className="col-2">
                        <a
                          href="https://x.com/IcarNrcb"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <TwitterIcon style={{ color: "1DB954" }} />
                        </a>
                      </div>
                      <div className="col-2">
                        <a
                          href="https://www.facebook.com/people/Icar-Nrcb/100011724194184/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FacebookIcon style={{ color: "1DB954" }} />
                        </a>
                      </div>
                      <div className="col-2">
                        <a
                          href="https://www.instagram.com/nrcb1993?igsh=MWY5Z29ibDJxNjR3bQ=="
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <InstagramIcon style={{ color: "1DB954" }} />
                        </a>
                      </div>
                      <div className="col-2">
                        <a
                          href="https://www.youtube.com/channel/UCSrJr5Bt7LQns-Nc69Rba0Q"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <YouTubeIcon style={{ color: "1DB954" }} />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-12">
                    <div className="row">
                      <div className="col-2">
                        <EmailIcon
                          className="m-auto"
                          style={{ color: "#1DB954" }}
                        />
                      </div>
                      <div className="col-10">
                        <p className="text-light">
                          <a href="mailto:directornrcb@gmail.com" style={{textDecoration: "none", color: "inherit"}}>
                            directornrcb@gmail.com
                          </a>
                        </p>
                        <p className="text-light">
                          <a href="mailto:nrcbdirector@gmail.com" style={{textDecoration: "none", color: "inherit"}}>
                            nrcbdirector@gmail.com
                          </a>
                        </p>
                        <p className="text-light">
                          <a href="mailto:NRCBebananastore@gmail.com" style={{textDecoration: "none", color: "inherit"}}>
                            NRCBebananastore@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-2">
                        <CallIcon style={{ color: "#1DB954" }} />
                      </div>
                      <div className="col-10">
                        <p className="text-light">0431-2618125</p>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-2">
                        <LanguageIcon style={{ color: "#1DB954" }} />
                      </div>
                      <div className="col-10">
                        {/* <p className='text-light'>https://nrcb.icar.gov.in/</p> */}
                        <a
                          href="https://nrcb.org.in/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-light"
                          style={{ textDecoration: "none" }}
                        >
                          ICAR - NRCB
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="text-white"></hr>
          <p className="text-light text-end d-flex justify-content-center align-items-center">
            {" "}
            © 2025 ICAR - NRCB. All Rights Reserved
          </p>
          {/* <p className='text-light text-end d-flex justify-content-center align-items-center'>
            {' '}
            Powered by{' '}
          </p> */}
          <div className="d-flex justify-content-center align-items-center mt-2">
            <a
              href="https://ramtech.pro/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={RamTech_IT_Logo}
                alt="RamTechITLogo"
                style={{
                  height: "2.5rem",
                  width: "7rem",
                  verticalAlign: "middle",
                  marginRight: "4px",
                }}
              />
            </a>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
